var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31632 12.5748C2.65231 11.7121 2.32031 11.2808 2.32031 10C2.32031 8.71922 2.65231 8.28791 3.31632 7.42526C4.64216 5.70278 6.86571 3.75 10.1328 3.75C13.3999 3.75 15.6234 5.70278 16.9493 7.42526C17.6133 8.28791 17.9453 8.71922 17.9453 10C17.9453 11.2808 17.6133 11.7121 16.9493 12.5748C15.6234 14.2972 13.3999 16.25 10.1328 16.25C6.86571 16.25 4.64216 14.2972 3.31632 12.5748Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 10C12.4766 11.2945 11.4273 12.3438 10.1328 12.3438C8.83836 12.3438 7.78906 11.2945 7.78906 10C7.78906 8.70555 8.83836 7.65625 10.1328 7.65625C11.4273 7.65625 12.4766 8.70555 12.4766 10Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpen);
export default __webpack_public_path__ + "static/media/icon-eye-open.3715aed4ec154ff33c3fbb082b2afbfe.svg";
export { ForwardRef as ReactComponent };